




















































































































import {Component, Prop, PropSync, Vue} from "vue-property-decorator";
import {
  IPerRoadLayerImperial,
  IPerRoadLayerMetric,
  IPerRoadSeasonImperial,
  PerRoadLayerType
} from "@/modules/perRoad/interfaces/perRoad";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import {poissonRatios} from "@/modules/perRoad/lib/poissonRatio";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import {
  getDefaultModulusDeterministic,
  newPavementStructureLayerFunctionsByType
} from "@/modules/structure/lib/createNew";
import {perRoadLayerImperialToMetric} from "@/modules/perRoad/lib/unitConversion/perRoadConversion";
import {temperatureAdjustedStiffnessPsi} from "@/modules/perRoad/lib/calculations/seasonalAdjustment";
import {ImperialUnits, MetricUnits} from "@/lib/unitConversion/unitConversionFactors";
import {convertDistributionImperialToMetric} from "@/lib/unitConversion/convertDistribution";
import {UnitSystem} from "@/interfaces/units";

@Component({
  components: {PxNumberInput, PxDropdown, PxTextEntryBox},
})
export default class PavementStructureLayerEditor extends Vue {
  @Prop({default: -1}) readonly id!: string;

  @PropSync('layer') layerSynced!: IPerRoadLayerImperial | IPerRoadLayerMetric;

  @Prop() layerImperial!: IPerRoadLayerImperial;

  @Prop() seasonsImperial!: IPerRoadSeasonImperial[];

  @Prop() unitSystemIsImperial!: boolean;

  @Prop() layerNumber!: number;

  @Prop() validations!: any;

  sync() {
    this.$emit('sync');
  }

  layerTypes = PerRoadLayerType;

  get layerMaterialTypeOptions() {
    return Object.values(PerRoadLayerType).map((value) => ({value, text: value}));
  }

  /**
   * Poisson's ratio
   */

  get layerPoissonDefaults() {
    // @ts-ignore
    return poissonRatios[this.layerSynced.type] ? poissonRatios[this.layerSynced.type] : {min: 0, max: 1};
  }

  /**
   * PG Grade
   */
  get pgGradeHighOptions() {
    /**
     * PG Grade High is the superpave high-temp performance limit for the pavement in deg C. Increments by 6 degrees C
     * https://pavementinteractive.org/reference-desk/materials/asphalt/superpave-performance-grading/
     */
    const values = [];
    for (let i = 46; i <= 82; i += 6) {
      values.push(i);
    }
    return values.map((v) => ({value: v, text: v}));
  }

  get pgGradeLowOptions() {
    /**
     * PG Grade low is the superpave low-temp performance limit for the pavement in deg C. Increments by 6 degrees C
     * https://pavementinteractive.org/reference-desk/materials/asphalt/superpave-performance-grading/
     */
    const values = [];
    for (let i = -40; i <= -10; i += 6) {
      values.push(i);
    }
    return values.map((v) => ({value: v, text: v}));
  }

  setPgGrade() {
    /**
     * Set PG grade and temp-aware modulus for AC pavements
     */

    const newDist = getDefaultModulusDeterministic(this.layerSynced.type);
    newDist.mean = temperatureAdjustedStiffnessPsi(
        this.layerSynced.pgGradeHigh!,
        this.seasonsImperial[0].temp_degF,
        this.layerImperial.thickness_in.mean || 0,
    );

    if (this.layerSynced.unitSystem === UnitSystem.Metric) {
      this.layerSynced.modulus_mpa[0] = convertDistributionImperialToMetric(
          newDist,
          ImperialUnits.PRESSURE_PSI,
          MetricUnits.PRESSURE_MPA,
      )
    } else {
      this.layerSynced.modulus_psi[0] = newDist;
    }
    this.sync();
  }


  /**
   * Modulus interface
   */

  get modulusUnit() {
    return this.unitSystemIsImperial ? 'psi' : 'MPa';
  }

  /**
   * Create new layers when the layer type changes
   */

  createNewLayer() {
    const newLayerType = this.layerSynced.type;
    const newLayerFcn = newPavementStructureLayerFunctionsByType[newLayerType];
    const newLayer = newLayerFcn(newLayerType, this.seasonsImperial);

    newLayer.name = `Default ${newLayer.type}`;

    if (this.unitSystemIsImperial) {
      this.$emit('new-layer', newLayer);
    } else {
      this.$emit('new-layer', perRoadLayerImperialToMetric(newLayer));
    }
  }


}

